export const GITHUB_CODING_AGENT_CONTEXT_STORAGE_KEY =
  'fly_coding_agent_context';

export const GITHUB_QUERY_PARAMS = {
  CODING_AGENT: 'coding_agent',
  RETURN_PROTOCOL: 'return_protocol',
  TARGET: 'target',
} as const;

export const ALLOWED_RETURN_PROTOCOLS = new Set(['cursor', 'vscode']);
